import PropTypes from "prop-types";
import { Link } from "@mui/material";
import { SocialPageIcon } from "../socialPageIcon/SocialPageIcon";
import { createSocialPageUrl } from "../../../utils/helpers";
import { MEDIA_CHANNELS } from "../../../constants";

export const SocialPageLink = ({ row }) => {
  if (!row.mediaChannelName) {
    return null;
  }

  if (
    row.socialAccountName &&
    row.mediaChannelName !== MEDIA_CHANNELS.linkedin
  ) {
    return (
      <Link
        href={createSocialPageUrl(row.mediaChannelName, row.socialAccountName)}
        target="_blank"
        sx={{
          "&": {
            display: "flex",
            textDecoration: "none",
            color: "inherit",
          },
          "&:hover, &:active": {
            color: (theme) => theme.palette.primary.main,
          },
        }}
        alignItems="center"
        gap="0.5rem"
      >
        <SocialPageIcon mediaChannel={row.mediaChannelName} />
      </Link>
    );
  } else {
    return (
      <SocialPageIcon
        mediaChannel={row.mediaChannelName}
        hasSocialAccount={false}
      />
    );
  }
};

SocialPageLink.propTypes = {
  row: PropTypes.object.isRequired,
};
